module.exports = __webpack_public_path__ + "static/media/FOOD-LOGO.47fe7645.png";